module.exports = {
      id: "icon-premium-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-premium",
      toString: function () {
        return this.url;
      }
    }